import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=45b2f3f1&scoped=true&"
import script from "./standard.vue?vue&type=script&lang=js&"
export * from "./standard.vue?vue&type=script&lang=js&"
import style0 from "./standard.vue?vue&type=style&index=0&id=45b2f3f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2f3f1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BackLink: require('/vercel/path0/components/general/BackLink.vue').default,RegisterForm: require('/vercel/path0/components/auth/RegisterForm.vue').default,Card: require('/vercel/path0/components/general/Card.vue').default})
